// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gh-section--form[data-v-df6c6fcc]{padding-top:0}", "",{"version":3,"sources":["webpack://./resources/assets/js/modules/credentialCourse/views/Download.vue"],"names":[],"mappings":"AACA,mCACI,aAAA","sourcesContent":["\n.gh-section--form {\n    padding-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
